import BulkPage from '../../components/pages/bulk'
export default BulkPage
